/* eslint-disable react/prop-types */
import SubmitContext from 'context/submit/submitContext'
import PageContext from 'context/page/pageContext'
import React, { useContext, useEffect, useState } from 'react'
import { Col, Row, FormGroup, Alert, Input } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import { packagingInitialState } from './constants'
import BSCornmealProduct from 'models/BSCornmealProduct'
import { isNotNumericDecimal } from 'context/Utilities'
import Switch from 'react-switch'

const BSCornmealPackage = () => {
  const submitContext = useContext(SubmitContext)
  const pageContext = useContext(PageContext)

  const { current, setCurrent, updating } = submitContext
  const { setScrollToTop } = pageContext

  const [packaging, setPackaging] = useState(packagingInitialState)

  const methods = useFormContext()

  const { onChange, setSwitch, asterisk } = useFormUtils()

  useEffect(() => {
    setScrollToTop(true)
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (current?.category === packagingInitialState.category) {
      const { category, subCategory, Size, FDACert, Organic } = current

      setPackaging({
        category,
        subCategory,
        Size,
        FDACert,
        Organic,
      })
    } else if (!updating) {
      setCurrent(BSCornmealProduct)
    }

    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [current])

  return (
    <Row>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Size {asterisk}</strong>
          </p>
          <Controller
            as={Input}
            type="number"
            step="0.01"
            name="Size"
            defaultValue={packaging.Size}
            placeholder={'12 - 48 ounces'}
            onKeyDown={e => {
              if (isNotNumericDecimal(e.key)) {
                e.preventDefault()
              }
            }}
            control={methods.control}
            rules={{
              maxLength: {
                value: 5,
                message: '⚠ Size exceeds 5 characters.',
              },
              min: {
                value: 12,
                message: '⚠ Size is below the required 12 ounce minimum.',
              },
              max: {
                value: 48,
                message: '⚠ Size exceeds the 48 ounces allowed.',
              },
              required: {
                value: true,
                message: '⚠ Please enter product size.',
              },
              pattern: {
                value: /^\d+(\.\d{1,2})?$/,
                message: '⚠ Maximum two decimal places allowed.',
              },
            }}
            onChange={([event]) => {
              onChange(event)
              return event
            }}
          />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="Size"
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
      <Col xs={6}>
        <FormGroup>
          <p>
            <strong>Organic</strong>
          </p>
          <Controller
            as={Switch}
            name="Organic"
            id="Organic"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.Organic}
          />
        </FormGroup>
        <hr />
        <FormGroup>
          <p>
            <strong>
              I certify that this product meets the FDA Standard of Identity{' '}
              <a
                href="https://www.ecfr.gov/current/title-21/section-137.260"
                target="_blank"
                rel="noopener noreferrer"
              >
                21 CFR 137.260
              </a>{' '}
              and aligns with{' '}
              <a
                href="https://foodbuyingguide.fns.usda.gov/FoodComponents/ResourceGrains"
                target="_blank"
                rel="noopener noreferrer"
              >
                USDA School Meal Guidance
              </a>
              . {asterisk}
            </strong>
          </p>
          <Controller
            as={Switch}
            name="FDACert"
            id="FDACert"
            onChange={([checked, event, id]) => {
              setSwitch(checked, event, id)
              return checked
            }}
            control={methods.control}
            defaultValue={packaging.FDACert}
            rules={{
              validate: FDACert => FDACert === true,
            }}
          />
          <br />
          <p className={'text-danger'}>
            <ErrorMessage
              errors={methods.errors}
              name="FDACert"
              message={
                '⚠ You must certify that this product meets the FDA Standard of Identity 21 CFR 137.260 and aligns with USDA School Meal Guidance.'
              }
              as={<Alert color={'danger'} className={'mt-3'} />}
            />
          </p>
        </FormGroup>
      </Col>
    </Row>
  )
}

export default BSCornmealPackage
